import { IPlans } from "../interfaces/api";
import { client } from "./client";

const cache = new Map();

export function getHealthPlans(
  year: number | string,
  zip: string,
  params: Record<string, any> = {}
): Promise<IPlans> | null {
  const key = `${year}-${zip}-${JSON.stringify(params)}`;

  if (!cache.has(key)) {
    try {
      const request = client
        .get<IPlans>("", {
          params: {
            methodName: "getHealthPlan",
            planyear: year,
            zipcode: zip,
            ...params,
          },
        })
        .then((response) => response.data);

      cache.set(key, request);
    } catch (error) {
      console.log("Error fetching health plan data:", error);
      return null;
    }
  }

  return cache.get(key);
}
